export default "__VITE_ASSET__BySogzPq__"